module.exports = __webpack_public_path__ + "static/salon-pasajeros---paquetera-8a060580999e60d5e1a089b6204baf75.jpg";